import { useState } from 'react';
import { turnosService } from '../../services/api';
import { btnSecundario, pesos, tarjeta } from '../../components/ui/estilos';

const fecha = (iso: string) => new Date(iso).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
const n = (v: any) => parseFloat(v || 0) || 0;

export default function HistorialTurnos({ turnos, onVolver }: { turnos: any[]; onVolver: () => void }) {
  const [abierto, setAbierto] = useState<{ turno: any; resumen: any } | null>(null);

  const alternar = async (id: string) => {
    if (abierto?.turno.id === id) { setAbierto(null); return; }
    const r = await turnosService.getById(id);
    setAbierto({ turno: r.data.turno, resumen: r.data.resumen });
  };

  return (
    <div style={{ maxWidth: 900, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={onVolver} style={btnSecundario}>‹ Volver al turno</button>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Historial de cortes</h1>
      </div>
      {!turnos.length && <p style={{ color: 'var(--muted)' }}>No hay turnos registrados.</p>}
      {turnos.map(t => {
        const dif = n(t.diferencia), sel = abierto?.turno.id === t.id;
        return (
          <div key={t.id} style={{ ...tarjeta, borderRadius: 14, overflow: 'hidden' }}>
            <button onClick={() => alternar(t.id)} aria-expanded={sel}
              style={{ width: '100%', textAlign: 'left', padding: '14px 18px', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink)', display: 'flex', justifyContent: 'space-between', gap: 12 }}>
              <span>
                <span style={{ display: 'block', fontSize: 16, fontWeight: 700 }}>{fecha(t.apertura_at)}{t.cierre_at ? ` → ${fecha(t.cierre_at)}` : ' · abierto'}</span>
                <span style={{ fontSize: 14, color: 'var(--muted)' }}>{t.usuario_apertura}{t.usuario_cierre ? ` · cerró ${t.usuario_cierre}` : ''}</span>
              </span>
              <span style={{ textAlign: 'right' }}>
                <span style={{ display: 'block', fontSize: 16, fontWeight: 700 }}>{t.total_ventas != null ? pesos(n(t.total_ventas)) : '—'}</span>
                {t.cierre_at && <span style={{ fontSize: 14, fontWeight: 700, color: Math.abs(dif) < .005 ? 'var(--ok)' : 'var(--danger)' }}>{Math.abs(dif) < .005 ? 'Exacto' : `${dif > 0 ? '+' : '−'}${pesos(Math.abs(dif))}`}</span>}
              </span>
            </button>
            {sel && abierto && (
              <div style={{ borderTop: '1px solid var(--line)', padding: '14px 18px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(160px, 100%), 1fr))', gap: 10 }}>
                  {[
                    ['Ventas', n(abierto.turno.total_ventas)], ['Efectivo', n(abierto.turno.total_ventas_efectivo)],
                    ['Propinas', n(abierto.turno.total_propinas)], ['Fondo inicial', n(abierto.turno.fondo_inicial)],
                    ['Entradas', n(abierto.turno.total_depositos)], ['Salidas', n(abierto.turno.total_retiros)],
                    ['Efectivo esperado', n(abierto.turno.efectivo_esperado)], ['Efectivo contado', n(abierto.turno.fondo_final)],
                  ].map(([k, v]) => (
                    <div key={k as string} style={{ padding: 12, borderRadius: 10, background: 'var(--bg)' }}>
                      <div style={{ fontSize: 13, color: 'var(--muted)' }}>{k}</div>
                      <div style={{ fontSize: 18, fontWeight: 700 }}>{pesos(v as number)}</div>
                    </div>
                  ))}
                </div>
                {abierto.resumen?.movimientos?.map((m: any) => (
                  <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15 }}>
                    <span>{m.tipo === 'deposito' ? 'Entrada' : 'Salida'} · {m.motivo}</span>
                    <span style={{ fontWeight: 700, color: m.tipo === 'deposito' ? 'var(--ok)' : 'var(--danger)' }}>{m.tipo === 'deposito' ? '+' : '−'}{pesos(n(m.monto))}</span>
                  </div>
                ))}
                {abierto.turno.notas_cierre && <p style={{ margin: 0, color: 'var(--muted)', fontStyle: 'italic' }}>{abierto.turno.notas_cierre}</p>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
